<template>
  <div :class="[ns.b(), ns.is(`${shadow}-shadow`), transparent ? ns.is(`transparent`) : '']">
    <div v-if="$slots.header || header" :class="ns.e('header')">
      <slot name="header">{{ header }}</slot>
    </div>
    <div :class="ns.e('body')" :style="bodyStyle">
      <sg-loading v-if="loading" fix></sg-loading>
      <slot></slot>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import { useNamespace } from '@sgui-plus/hooks'
import { cardProps } from './card'

import SgLoading from '@sgui-plus/components/loading'

export default defineComponent({
  name: 'SgCard',
  props: cardProps,
  components: { SgLoading },
  setup() {
    const ns = useNamespace('card')

    return {
      ns
    }
  },
})
</script>
